module.exports = __webpack_public_path__ + "static/media/carousel3.5ed32391.jpeg";